<template>
  <v-app :dark="isDark">
    <div id="app">
      <component :is="layout">
        <transition name="slide-fade" mode="out-in">
          <router-view/>
        </transition>
      </component>
    </div>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      defaultLayout: 'auth'
    }
  },
  computed: {
    layout () {
      return (this.$route.meta.layout || this.defaultLayout) + '-layout'
    },
    isDark () {
      if (this.$store.state.auth.userInfo.themeColor === '0') return true
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/App.vue